import MyImage from "../assets/images/makesh.jpeg"

export const profileData = {
  id: 1,
  name: "Makeshwaran",
  designation: "Full Stack Developer",
  description: `There wasn't a bird in the sky, but that was not what caught his attention. It was the clouds. The deep green that isn't the color of clouds, but came with these. He knew what was coming and he hoped he was prepared.`,
  CTA_label: "Contact Me",
  CTA_link: "/contact",
  image: MyImage,
};
